import { type ReactNode } from 'react';
import { Logo } from '@yhelp/ui';

export interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-4 py-12 page-enter dark:bg-neutral-950">
      <main className="surface-elevated w-full max-w-md p-8">
        <header className="mb-6 flex flex-col items-center gap-4 text-center">
          <Logo variant="official" size="md" />
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight text-yhelp-black dark:text-white">
              {title}
            </h1>
            {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
          </div>
        </header>
        {children}
      </main>
      <p className="mt-6 text-xs text-muted">© yHelp — ySec · Cloudflare</p>
    </div>
  );
}
